// extracted by mini-css-extract-plugin
export default {"root":"LorRichText_root__go9sv","editing":"LorRichText_editing__Jpk9U","editor":"LorRichText_editor__XT1rG","toolbar":"LorRichText_toolbar__W9c8A","tool":"LorRichText_tool__4zLJl"};